import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';
import { isLiveChatMode } from '../../messageChannel/chatCreators';

export interface ILiveChatChangeMode {
  readonly id: string;
  readonly type: MESSAGES.CHANGE_MODE;
  readonly role: ROLE.BOT;
  readonly rm: false;
  readonly avatar: boolean;
  readonly isLiveChat: boolean;
  readonly overwriteWithKey?: string;
  readonly ticketId: string;
  readonly isTransferred: boolean;
  readonly clientOnly?: boolean;
}

export const createModeMessage = (data): ILiveChatChangeMode => ({
  id: data.id || uuid(),
  type: MESSAGES.CHANGE_MODE,
  role: ROLE.BOT,
  rm: false,
  avatar: true,
  isLiveChat: isLiveChatMode(data.mode),
  ticketId: String(data.ticketId),
  isTransferred: data.isTransferred as boolean,
  clientOnly: data.clientOnly ?? false,
  ...(data.overwriteWithKey && { overwriteWithKey: data.overwriteWithKey }),
});
